export default "__VITE_ASSET__5DfZZ6F4__"